import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
const AgentAccountDisableForm = () => {
  return (
    <div className="container page">
      <div className="col-md-6 offset-md-3 col-xs-12">
        <Card boxShadow={3}>
          <CardContent>
            <div className="headerAlign text-xs-center">
              <Typography
                className="title-h5"
                gutterBottom
                variant="h4"
                color="primary"
              >
                Your user account has been locked.
              </Typography>
              <Typography
                display="block"
                gutterBottom
                variant="body"
                className="text-xs-center"
                paragraph={true}
              >
                Please contact 1800-226-3545 to unlock your account.
              </Typography>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
export default AgentAccountDisableForm;
